
import { useLocation } from "react-router-dom";
import { Carousel, Card, message, Tabs, Button, Space } from 'antd';
import { getFileUrl } from "@/utils/FileUtil";
import { useEffect, useState } from "react";
import { getExchangeAmount } from "@/utils/CurrenyUtil"
import { getCommodityDetail } from "@/api/commodity/commodity";
import ImageDownload from "./ImageDownload";
import ResourceDownload from "./ResourceDownload";
import "./detail.css"

const CommodityDetail = () => {

    const [messageApi, contextHolder] = message.useMessage();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const commodityId = queryParams.get("id")
    const [commodity, setCommodity] = useState({});

    const [fileUrls, setFileUrls] = useState([]);
    const [imgFileInfos, setImgFileInfos] = useState([]);
    const [resourceFileInfos, setResourceFileInfos] = useState([]);
    const [selectedSpec, setSelectedSpec] = useState({})
    const isAuthed = localStorage.getItem('token') ? true : false

    // 当前选中的SKU
    const [currentSku, setCurrentSku] = useState({})

    useEffect(() => {
        queryDetail();
    }, [])

    useEffect(() => {
        specChanged();
    }, [selectedSpec])

    const queryDetail = async () => {
        let res = await getCommodityDetail({ id: commodityId })
        if (res && res.code === "0") {
            let currentCommodity = res.data
            let specs = JSON.parse(currentCommodity.specs || "[]")
            currentCommodity.specsList = specs;
            setCommodity(currentCommodity)
            let currency = currentCommodity.commodityDetails[0]?.currency
            let changePrice = await getExchangeAmount(currency, "CNY", currentCommodity.price)
            let changeSalesMinPrice = await getExchangeAmount(currency, "CNY", currentCommodity.salesMinPrice)
            setCurrentSku({
                price: currentCommodity.price,
                salesMinPrice: currentCommodity.salesMinPrice,
                currencySymbol: currentCommodity.commodityDetails[0]?.currencySymbol,
                currency: currency,
                changePrice,
                changeSalesMinPrice
            })
            // 预览图片地址解析
            await getFileUrls(currentCommodity.imgFileList)
            // 图片文件
            let imgs = [{ key: "", value: currentCommodity.imgFileList }]
            setImgFileInfos(imgs)
            // 压缩文件
            setResourceFileInfos(currentCommodity.resourceFileList)
            return
        }
        messageApi.error("获取商品详情失败：" + res.message || "原因未知")
    }

    const getFileUrls = async (files) => {
        let fileArr = []
        files = files || []
        for (let i = 0; i < files.length; i++) {
            let url = files[i].filePath
            url = await getFileUrl(url)
            if (url) {
                fileArr.push(url)
            }
        }
        setFileUrls(fileArr)
    }

    // 规格选择
    const handleSpecClick = (specType, specValue) => {
        let newSelectedSpec = JSON.parse(JSON.stringify(selectedSpec))
        newSelectedSpec[specType] = specValue
        setSelectedSpec(newSelectedSpec)
    }
    // 规格变化
    const specChanged = async () => {
        let findItem = null
        for (let item of commodity.commodityDetails || []) {
            let matched = true
            const itemSpec = JSON.parse(item.specValue || "{}")
            for (const specType in selectedSpec) {
                if (itemSpec[specType] != selectedSpec[specType]) {
                    matched = false
                    break
                }
            }
            if (matched) {
                findItem = item
                break
            }
        }
        if (!findItem) {
            return
        }
        let changePrice = await getExchangeAmount(findItem.currency, "CNY", findItem.price)
        let changeSalesMinPrice = await getExchangeAmount(findItem.currency, "CNY", findItem.salesMinPrice)
        setCurrentSku({
            price: findItem.price,
            salesMinPrice: findItem.salesMinPrice,
            currencySymbol: findItem.currencySymbol,
            currency: findItem.currency,
            skuCode: findItem.skuCode,
            skuName: findItem.skuName,
            changePrice,
            changeSalesMinPrice
        })
        // 取不到具体明细的图片的，使用主图
        if (findItem.skuImgFileList?.length > 0) {
            await getFileUrls(findItem.skuImgFileList)
        } else {
            await getFileUrls(commodity.imgFileList)
        }
    }

    return (
        <Card className="commodity-detail-container">
            {contextHolder}
            <div className="commodity-content">
                <div className="carousel-container">
                    <Carousel fade dotPosition="bottom" arrows >
                        {
                            fileUrls.map(file => (
                                <img src={file} key={file} className="carousel-img" />
                            ))
                        }
                    </Carousel>
                </div>
                <div className="commodity-info">
                    <Space size={10} style={{ display: "flex", flexDirection: "column" }} align="start">
                        <h3 className="commodity-title">商品名称：{commodity.commodityName}</h3>
                        {commodity.commodityType === "1" ? (
                            <>
                                <div>SKU编号：{currentSku.skuCode}</div>
                                <div>SKU名称：{currentSku.skuName}</div>
                                <div className="price-section">供货价格：
                                    <span className="price-amount">
                                        {currentSku.currencySymbol + " " + currentSku.price}
                                    </span>
                                    <div className="price-conversion">（{currentSku.changePrice} 元）</div>
                                </div>
                                <div className="price-section">销售控价：
                                    <span className="price-amount">
                                        {currentSku.currencySymbol + " " + currentSku.salesMinPrice}
                                    </span>
                                    <div className="price-conversion">（{currentSku.changeSalesMinPrice} 元）</div>
                                </div>
                            </>
                        ) : null}
                        {commodity.commodityType === "2" ? (
                            <div className="price-section">价格：
                                <span className="price-amount">
                                    {commodity.extraRemark}
                                </span>
                            </div>
                        ) : null}
                        {
                            commodity.commodityType !== "2" ? (
                                <div style={{ whiteSpace: "normal", wordBreak: "break-all" }}>备注：{commodity.extraRemark}</div>
                            ) : null
                        }
                        <div>
                            {commodity.specsList?.map(item => (
                                <div key={item.specType} className="spec-item">
                                    <span className="spec-type">{item.specType}</span><br />
                                    <div className="spec-values">
                                        {
                                            item.values.map(value => (
                                                <Button
                                                    key={value}
                                                    shape="round"
                                                    className="spec-button"
                                                    type={selectedSpec[item.specType] === value ? 'primary' : 'default'}
                                                    onClick={() => handleSpecClick(item.specType, value)}>
                                                    {value}
                                                </Button>
                                            ))
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Space>
                </div>
            </div>
            <div className="tabs-container">
                <Tabs
                    defaultActiveKey="1"
                    disabled={!isAuthed}
                    size="large"
                    items={[
                        {
                            key: '1',
                            label: '图片素材',
                            children: <ImageDownload files={imgFileInfos} />,
                        }, {
                            key: '2',
                            label: '产品资料压缩包',
                            children: <ResourceDownload files={resourceFileInfos} />,
                        },
                    ]}
                    onChange={() => { }}
                />
            </div>
            <div style={{ marginTop: "20px" }}>
                <div className="description-title">商品描述：</div>
                <pre className="description-content">{commodity.description}</pre>
            </div>
        </Card>
    )
}

export default CommodityDetail;